import { render, staticRenderFns } from "./PrizesPayments.vue?vue&type=template&id=9788f288&scoped=true"
import script from "./PrizesPayments.js?vue&type=script&lang=js&external"
export * from "./PrizesPayments.js?vue&type=script&lang=js&external"
import style0 from "./PrizesPayments.scss?vue&type=style&index=0&id=9788f288&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9788f288",
  null
  
)

export default component.exports